"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=(e,t)=>{throw new Error(`Unhandled action type: ${t.type}`)};exports.useReducers=t=>(r,o)=>((null==t?void 0:t[o.type])||e)(r,o);
//# sourceMappingURL=hooks.js.map
